import { render, staticRenderFns } from "./GStudentRecordItemCell.vue?vue&type=template&id=c7a7326c&scoped=true&"
import script from "./GStudentRecordItemCell.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordItemCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a7326c",
  null
  
)

export default component.exports